// extracted by mini-css-extract-plugin
export default {"box":"index_box_PWGlo","footer":"index_footer_8vpkt"};